import type { AppModule } from '@/types/architecture'
import routes from './routes'

/**
 * Fab Schedule Module — Fabrication Job Scheduling & Timeline
 *
 * Nested under the "Warehouse" navigation header.
 * Provides schedule management for panel fabrication across locations.
 */
const fabScheduleModule: AppModule = {
    id: 'fab-schedule',
    navigation: {
        label: 'Warehouse',
        icon: 'warehouse',
        path: '/warehouse/fab-schedule',
        order: 78,
        moduleKey: 'fab_scheduler',
        pages: [
            {
                label: 'Fab Schedule',
                path: '/warehouse/fab-schedule',
                icon: 'calendar-days',
            },
            {
                label: 'Import Schedule',
                path: '/warehouse/import-schedule',
                icon: 'file-up',
            },
        ],
    },
    routes,
}

export default fabScheduleModule
